import { useBusinessTypeFeatures } from "@/hooks/useBusinessTypeFeatures";
import { AdminLink, OwnerLink } from "@/components/layout/sidebar/types";

export const useFilteredLinks = (
  userType: "admin" | "owner",
  links: (AdminLink | OwnerLink)[]
) => {
  const { businessTypeFeatures } = useBusinessTypeFeatures();

  return userType === "admin"
    ? links
    : (links as OwnerLink[]).filter(link => {
        if (!link.feature) return true;
        if (link.feature === "dashboard") return true;
        
        if (link.requireFeature) {
          return businessTypeFeatures?.[link.feature] === true;
        }
        
        return businessTypeFeatures?.[link.feature as keyof typeof businessTypeFeatures] !== false;
      });
};